// seasonPaths.js
import { doc, collection } from "firebase/firestore";
import { db } from "../lib/firebase";

// Store active season ID, defaulting to "S1"
let _activeSeasonID = "S1";

/**
 * Sets the active season ID globally so all path helpers use the correct season.
 */
export function setActiveSeasonID(seasonID) {
  if (typeof seasonID === "string" && seasonID.trim() !== "") {
    _activeSeasonID = seasonID;
  } else {
    console.warn("Invalid seasonID passed to setActiveSeasonID:", seasonID);
  }
}

/**
 * Returns the active season ID.
 */
export function getSeasonID() {
  return _activeSeasonID;
}

/**
 * Accepts a full path array like:
 * ["leagues", leagueID, "seasons", seasonID, "players"]
 */
export function resolveCollectionPath(pathArray) {
  return collection(db, ...pathArray);
}

/**
 * Accepts a full doc path array like:
 * ["leagues", leagueID, "seasons", seasonID, "players", playerID]
 */
export function resolveDocPath(pathArray) {
  return doc(db, ...pathArray);
}